// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { usePendingIncomingPayment, getSafeCipCode } from '@tectonics/prs/incoming-payment';
import { RenderVoucherText } from '../commons/voucher/render-voucher-text';
import { DisplayBarcodeNumber } from './display-barcode-number';

type TextDisplayProps = {
  title: string,
  value: string,
  lastItem?: boolean,
}

export function TextDisplay({title, value, lastItem = false}: TextDisplayProps): Node {
  const renderHrOrDont = (lastItem) => {
    if(lastItem !== true) {
      return <Hr />;
    }
  };

  const incomingPayment = usePendingIncomingPayment();
  let renderedCode = value;
  switch(value) {
    case 'cip':
      renderedCode = getSafeCipCode(incomingPayment);
      break;
    case 'get_pagosnet_barcode':
      renderedCode = <DisplayBarcodeNumber redesign={true} />;
  }

  return (
    <Root data-test-id="cip-code">
      <Label>{RenderVoucherText({title})}</Label>
      <Code>{renderedCode}</Code>
      {renderHrOrDont(lastItem)}
    </Root>
  );
}

const Root = styled.div`
  color: ${props => props.theme.colors.gray};
  font-weight: 500;
  text-align: left;
  width: 75%;
  margin-left: auto;
  margin-right: auto;
`;

const Label = styled.div`
  font-size: 1.1em;
  margin-top: .5em;
`;

const Code = styled.div`
  font-size: 1.5em;
  font-weight: 900;
`;

const Hr = styled.hr`
  display: block; height: 1px;
  border: 0;
  border-top: 1px solid rgb(220,225,230);
  margin: 0.6em 0; padding: 0;
`;
